import axios from 'axios'

class Transcript {
  static async search(searchKey) {
    const res = await axios.get(`classroom/transcripts?searchKey=${searchKey}`)

    return res.data
  }
}

export default Transcript
